export const SUPPORT_PHONE_NUMBER = '380971548532,380631408850';
export const SUPPORT_VIBER_CHAT = 'viber://pa?chatURI=rieltoruabot';

export const GOOGLE_PLAY_APP = 'https://play.google.com/store/apps/details?id=ua.rieltor.app&hl=uk&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
export const SOCIAL_VIBER = 'https://invite.viber.com/?g2=AQA7NLBF7J3YWEnUGCvZ%2BL9K6gmuIOnKlseffG1T35JrDjE5%2BGtFJ24HnQm5Ev%2Fe';
export const SOCIAL_FACEBOOK = 'https://www.facebook.com/www.rieltor.ua/';
export const SOCIAL_INSTAGRAM = 'https://www.instagram.com/rieltor.ua/';
